import { HttpClient } from "../index";
import { getCategoriesEndPoint, getVPTypesEndPoint, getVPTypesByIdEndPoint, getVpByPackageAndTypeEndPoint } from "../util/apiEndpoints";

class VPTypeManager {
  //Get list of VP-types i.e [{id:1, type: "0_2_MONTHS"}, {id:2, type: "3_5_MONTHS"}]
  getTypes(token) {
    const httpClient = new HttpClient(token);
    return httpClient.get(getVPTypesEndPoint()).then(result => {
      return result;
    });
  }

  //Get list of VP-types defined by vp-type-id i.e [{id:1, type: "0_2_MONTHS"}, {id:2, type: "3_5_MONTHS"}]
  getTypesById(token, vpTypeId) {
    const httpClient = new HttpClient(token);
    return httpClient.get(getVPTypesByIdEndPoint(vpTypeId)).then(result => {
      return result;
    });
  }

  //Get list of VP Categories i.e ['A', 'B', 'C', ...] etc
  getCategories(token) {
    const httpClient = new HttpClient(token);
    return httpClient.get(getCategoriesEndPoint(), null).then(result => {
      return result;
    });
  }

  getVpByPackageAndType(token, packageId, vpTypeId) {
    const httpClient = new HttpClient(token);
    return httpClient
      .get(getVpByPackageAndTypeEndPoint(packageId, vpTypeId))
      .then(result => {
        return result;
      });
  }
}

const vpTypeManager = new VPTypeManager();
export default vpTypeManager;



// WEBPACK FOOTER //
// ./retts/VP/VPTypeManager.js